"use client";

import { useLang } from "@/contexts/language-context";
import AnimatedSection from "../AnimatedSection";
import AppStoreBadges from "../AppStoreBadges";

export default function HardwareGetApp() {
  const { t } = useLang();

  return (
    <section className="py-20 px-6 bg-white border-y border-black/5">
      <div className="max-w-[900px] mx-auto text-center">
        <AnimatedSection>
          <div className="text-[11px] font-bold tracking-widest uppercase text-redy-orange mb-4">
            {t("The app", "La app")}
          </div>
          <h2 className="text-3xl md:text-[44px] font-black tracking-tight leading-[1.08] text-redy-charcoal mb-4">
            {t("Redy POS is on both stores.", "Redy POS está en las dos tiendas.")}
          </h2>
          <p className="text-[15px] font-medium text-redy-secondary max-w-xl mx-auto mb-8">
            {t(
              "Install it on the tablet you already own — POS, kitchen display, kiosk and customer display, all from the same app.",
              "Instálala en la tablet que ya tienes — POS, pantalla de cocina, kiosko y pantalla del cliente, todo desde la misma app."
            )}
          </p>
          <AppStoreBadges className="justify-center" height={48} />
          <p className="text-[12.5px] font-medium text-redy-secondary/70 mt-6">
            {t(
              "Any iPad (iPad 7 and newer) · Any Android tablet (Android 10+)",
              "Cualquier iPad (iPad 7 o más nuevo) · Cualquier tablet Android (Android 10+)"
            )}
          </p>
        </AnimatedSection>
      </div>
    </section>
  );
}
